import $ from 'jquery';

const inputs = document.getElementsByClassName('form-autocomplete');
if (inputs && inputs.length) {
  window.addEventListener('load', () => {
    for (let index = 0; index < inputs.length; index++) {
      const input = inputs[index];
      $(input).autocomplete({
        open: () => {
          input.classList.add('form-autocomplete--open');
          const menus = Array.from(document.getElementsByClassName('ui-autocomplete'));
          menus.forEach((menu) => menu.style.transform = `translateY(10px)`)
        },
        close: () => {
          input.classList.remove('form-autocomplete--open');
          const menus = Array.from(document.getElementsByClassName('ui-autocomplete'));
          menus.forEach((menu) => menu.style.transform = '')
        }
      });
    }
  });
}
